// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".size[data-v-9d7894c8]{color:#3a3830;margin-right:5px;font-size:16px;font-weight:500}.size-descriptor[data-v-9d7894c8]{font-size:12px;font-weight:400}.size-descriptors[data-v-9d7894c8]{display:flex;flex-wrap:wrap;gap:5px}", ""]);
// Exports
module.exports = exports;
